<template>
  <section v-if="id && babyInfo" class="evaluation-result">
    <ElCard class="no-padding">
      <div class="intro"><i class="el-icon-check"></i>体质体格评测结果</div>
      <div class="baby echarts">
        <div class="child">
          <div
            v-show="physicalImg && babyInfo.system"
            class="physicalImg content"
          >
            <div ref="physicalImg" class="echarts"></div>
            <template v-if="babyInfo.system.result">
              <p class="title two-line">
                初步测试孩子的体质为：{{ babyInfo.system.result }}
              </p>
              <p>主要特征：{{ babyInfo.system.detail }}</p>
              <p>调养法则：{{ babyInfo.system.rule }}</p>
              <p
                v-if="
                  babyInfo.system.question && babyInfo.system.question.length
                "
              >
                潜在问题：
              </p>
              <p v-for="(item, index) in babyInfo.system.question" :key="index">
                {{ index + 1 }}、{{ item }}
              </p>
            </template>
          </div>
          <NoContent v-show="!(physicalImg && babyInfo.system)" />
        </div>
        <div
          v-show="
            heightImg &&
              weightImg &&
              babyInfo.physique.height &&
              babyInfo.physique.weight
          "
          class="child"
        >
          <div class="heightImg content">
            <div ref="heightImg" class="echarts"></div>
          </div>
          <div v-if="babyInfo.physique.height.result" class="content">
            <p class="title">
              身高分析：宝宝身高{{ babyInfo.physique.height.result.num }}
            </p>
            <p class="title next">
              标准范围{{ babyInfo.physique.height.result.range }}
            </p>
            <p>评测结果：{{ babyInfo.physique.height.say }}</p>
            <p>调养法则：{{ babyInfo.physique.height.rule }}</p>
            <p
              v-if="
                babyInfo.physique.height.question &&
                  babyInfo.physique.height.question.length
              "
            >
              潜在问题：
            </p>
            <p
              v-for="(item, index) in babyInfo.physique.height.question"
              :key="index"
            >
              {{ index + 1 }}、{{ item }}
            </p>
          </div>
        </div>
        <div
          v-show="
            heightImg &&
              weightImg &&
              babyInfo.physique.height &&
              babyInfo.physique.weight
          "
          ref="chartHeightWeight"
          class="child"
        >
          <div class="weightImg content">
            <div ref="weightImg" class="echarts"></div>
          </div>
          <div v-if="babyInfo.physique.weight.result" class="content">
            <p class="title">
              体重分析：宝宝体重{{ babyInfo.physique.weight.result.num }}
            </p>
            <p class="title next">
              标准范围{{ babyInfo.physique.weight.result.range }}
            </p>
            <p>评测结果：{{ babyInfo.physique.weight.say }}</p>
            <p>调养法则：{{ babyInfo.physique.weight.rule }}</p>
            <p
              v-if="
                babyInfo.physique.weight.question &&
                  babyInfo.physique.weight.question.length
              "
            >
              潜在问题：
            </p>
            <p
              v-for="(item, index) in babyInfo.physique.weight.question"
              :key="index"
            >
              {{ index + 1 }}、{{ item }}
            </p>
          </div>
        </div>
        <div
          v-show="
            !(
              heightImg &&
              weightImg &&
              babyInfo.physique.height &&
              babyInfo.physique.weight
            )
          "
          class="child child2"
        >
          <NoContent />
        </div>
      </div>
    </ElCard>
    <!-- 解决方案 -->
    <Solution
      :hand-list="handList"
      :hand-list-simple="handListSimple"
      :say-list="sayList"
      :food-list="foodList"
      :food-book="foodBook"
      :progress="progress"
    ></Solution>
    <!-- 门店推荐 -->
    <RecomendDoctorRes
      :id="id"
      :commodity="commodity"
      :type="'member'"
    ></RecomendDoctorRes>
    <div class="tips">
      所有内容仅供参考，不可替代医师处方。
    </div>
  </section>
  <ElCard v-else>
    <NoContent />
  </ElCard>
</template>

<script>
import $ from 'jquery';
import echarts from 'echarts';
import {http, catchAppError} from '@/util';
import url from '@/config';
import Solution from '@/components/advisory/advisoryDetail/solution';
import RecomendDoctorRes from '@/components/advisory/advisoryDetail/recomendDoctorRes';
import NoContent from '@/components/evaluation/NoContent.vue';

export default {
  name: 'TiZhiTiGeResult',
  components: {NoContent, Solution, RecomendDoctorRes},
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chartWidth: 0,
      babyInfo: null,
      physicalImg: null,
      heightImg: null,
      weightImg: null,
      handList: null,
      handListSimple: null,
      sayList: null,
      foodList: null,
      progress: null,
      commodity: null
    };
  },
  watch: {
    chartWidth() {
      this.initWeightChart();
      this.initWeightChart();
      this.initPhysicalChart();
    }
  },
  mounted() {
    http
      .post(url.testResult, {u_id: this.id})
      .then(res => {
        this.babyInfo = res;
        if (!this.babyInfo) return;
        this.handList = res.solution.hand;
        this.handListSimple = res.solution.hand_simple;
        this.sayList = res.solution.solution.sayList;
        this.foodList = res.solution.solution.foodList;
        this.foodBook = res.solution.solution.foodBook;
        this.progress = res.solution.solution;
        this.commodity = res.product.commodity;
        this.chartWidth = $('.member-list-card').width() / 3 - 50;
        this.getCharts();
      })
      .catch(catchAppError);
  },
  methods: {
    getCharts() {
      http
        .post(url.physicalImg, {u_id: this.id})
        .then(res => {
          this.physicalImg = res;
          this.initPhysicalChart();
        })
        .catch(catchAppError);
      http
        .post(url.heightImg, {u_id: this.id})
        .then(res => {
          this.heightImg = res;
          this.initHeightChart();
        })
        .catch(catchAppError);
      http
        .post(url.weightImg, {u_id: this.id})
        .then(res => {
          this.weightImg = res;
          this.initWeightChart();
        })
        .catch(catchAppError);
    },
    initPhysicalChart() {
      if (!this.physicalImg) return;
      this.$refs.physicalImg.style.width = `${this.chartWidth}px`;
      const physicalChart = echarts.init(this.$refs.physicalImg);
      const physicalOption = {
        tooltip: {},
        grid: {
          top: 10,
          bottom: 0,
          left: 0,
          right: 0,
          containLabel: true,
          show: true
        },
        xAxis: {
          data: this.physicalImg.name,
          axisLabel: {
            fontSize: 10,
            interval: 0,    //强制文字产生间隔
					  rotate: 45,     //文字逆时针旋转45°
						textStyle: {    //文字样式
						            color: "black",
						            fontSize: 16,
						            fontFamily: 'Microsoft YaHei'
						            }
          }
        },
        yAxis: {},
        series: [
          {
            name: '体质',
            type: 'bar',
            data: this.physicalImg.grade
          }
        ]
      };
      physicalChart.setOption(physicalOption);
    },
    initHeightChart() {
      if (!this.heightImg) return;
      this.$refs.heightImg.style.width = `${this.chartWidth}px`;
      const myChart = echarts.init(this.$refs.heightImg);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          bottom: 0,
          left: 0,
          containLabel: true,
          show: true
        },
        legend: {
          orient: 'horizontal'
        },
        xAxis: {
          scale: true
        },
        yAxis: {},
        series: [
          {
            name: '标准线',
            symbolSize: 0,
            smooth: true,
            type: 'line',
            data: this.heightImg.data[0].data
          },
          {
            name: '宝宝身高',
            symbolSize: 10,
            itemStyle: {
              normal: {
                color: '#000',
                lineStyle: {
                  color: '#000'
                }
              }
            },
            type: 'scatter',
            data: this.heightImg.data[1].data
          }
        ]
      };
      myChart.setOption(option);
    },
    initWeightChart() {
      if (!this.weightImg) return;
      this.$refs.weightImg.style.width = `${this.chartWidth}px`;
      const myChart = echarts.init(this.$refs.weightImg);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          bottom: 0,
          left: 0,
          containLabel: true,
          show: true
        },
        legend: {
          orient: 'horizontal'
        },
        xAxis: {
          scale: true
        },
        yAxis: {},
        series: [
          {
            name: '标准线',
            symbolSize: 0,
            smooth: true,
            type: 'line',
            data: this.weightImg.data[0].data
          },
          {
            name: '宝宝体重',
            symbolSize: 10,
            itemStyle: {
              normal: {
                color: '#000',
                lineStyle: {
                  color: '#000'
                }
              }
            },
            type: 'scatter',
            data: this.weightImg.data[1].data
          }
        ]
      };
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss">
.evaluation-result {
  font-size: 16px;
  .baby.one {
    font-size: 16px;
  }
  .baby-info {
    position: relative;
  }
  .btn-search-record {
    position: absolute;
    right: 40px;
    bottom: 20px;
  }
  .tips {
    position: absolute;
    width: 100%;
    text-align: left;
    color: #ff7022;
    left: 0;
    font-size: 16px;
    line-height: 30px;
  }
  .intro {
    position: relative;
    font-size: 16px;
    padding: 10px 25px;
    color: #4b90ff;
    background-color: #fafafa;
  }
  .no-padding {
    .el-card__body {
      padding: 0;
    }
  }
  .baby {
    display: flex;
    flex-wrap: wrap;
    &.echarts {
      .child {
        padding-bottom: 15px;
        .title {
          color: #4b90ff;
          font-size: 16px;
          &.two-line {
            height: 68px;
          }
          &.next {
            padding-left: 60px;
          }
        }
        p {
          line-height: 2.8333;
          margin: 0;
          font-size: 16px;
        }
      }
    }
    &.one {
      margin-top: -40px;
      .child {
        width: 25%;
        margin-top: 40px;
        border-left: none;
      }
    }
    .child {
      box-sizing: border-box;
      width: 33.33%;
      padding-top: 20px;
      border-left: 1px solid #ccc;
      &.child2 {
        width: 66.66%;
      }
      .content {
        padding-left: 25px;
        padding-right: 25px;
        .echarts {
          width: 300px;
          height: 300px;
          margin-left: auto;
          margin-right: auto;
        }
      }
      &:first-child {
        border-left: none;
      }
    }
  }
}
</style>
